<template>
  <panel :url="url"
         :bg-url="bgUrl"
         bg-align="left-top"
         :content="content"
         section="社媒引流">
  </panel>
</template>

<script>
import panel from './panel-3'

export default {
  components: {
    panel,
  },
  data () {
    return {
      url: require('@/assets/access_images/access-facebook-effect.png'),
      bgUrl: require('@/assets/access_images/access-facebook-effect_bg.png'),
      content: [
        '有超过45亿人使用互联网，社交媒体用户已经突破38亿大关！',
        'Facebook拥有成熟运营模式及丰富的广告资源'
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
</style>